import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { ContractRestrictions } from 'app/core/store/contract-details/contract-details.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Place } from 'app/core/interfaces/place.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';

export interface CustomerInfo {
  loading: boolean;
  loaded: boolean;
  failed: boolean;
  customer: Customer;

  defaults: {
    localCurrency: string;
    depot: {
      id: string;
      type: string;
      address: string;
      name: string;
      openingHours: string;
    };
  };

  restrictions: ContractRestrictions;

  places: { [key: string]: Place };
  orderTypes: Definition[];
  flowRegistrationTypes: Definition[]; // Used for creating flows
  flowHandshakeTypes: Definition[]; // Used for creating flow handshakes
  allFlowTypes: Definition[];

  salesOrganisation: SalesOrganisationInfo<Contact>;

}

export interface Contact {
  key: string;
  phoneNumber: string;
  emailAddress: string;
}

export interface ContactTO {
  Id: string;
  SalesOrganisationId: string;
  Label: string;
  PhoneNumber: string;
  Email: string;
}

export interface SalesOrganisationInfo<C = Contact> {
  id: string;
  contacts: C[];
}

export interface CustomerInfoTO {
  authorizationMatrix: AuthorizationMatrix;
  defaults: {
    localCurrency: string;
    depot: {
      id: string;
      type: string;
      address: string;
      name: string;
      openingHours: string;
    };
  };
  salesOrganisation: SalesOrganisationInfo<ContactTO>;
  blankReceiptPossible?: boolean;
  deviationManagement?: boolean;
  GS1LineRef?: boolean;
  useCcrValidation?: boolean;
  overruleMaxQty?: boolean;
  sealNumberRequired?: boolean;
  palletExchange?: boolean;
  shipTos: { [key: string]: string };
  orderTypes?: string[];
  flowRegistrationTypes?: string[]; // Used for creating flows
  flowHandshakeTypes?: string[]; // Used for creating flow handshakes
}
